import { z } from "zod";
import { createApiResponseSchema } from "./response.js";
const ORD_STAT = {
  \uC785\uAE08\uB300\uAE30: 0,
  // Default Number
  \uC811\uC218\uB300\uAE30: 1,
  \uB300\uCCB4\uC785\uAE08: 2,
  \uC811\uC218\uC9C4\uD589: 10,
  \uC0C1\uB2F4\uB300\uAE30: 12,
  \uC0DD\uC0B0\uC9C4\uD589: 20,
  \uC0DD\uC0B0\uC644\uB8CC: 30,
  \uCD9C\uACE0\uB300\uAE30: 70,
  \uCD9C\uACE0\uC644\uB8CC: 80,
  \uC8FC\uBB38\uCDE8\uC18C: 90
};
const OrderStatusEnum = z.enum([
  "\uC785\uAE08\uB300\uAE30",
  "\uC811\uC218\uB300\uAE30",
  "\uB300\uCCB4\uC785\uAE08",
  "\uC811\uC218\uC9C4\uD589",
  "\uC0C1\uB2F4\uB300\uAE30",
  "\uC0DD\uC0B0\uC9C4\uD589",
  "\uC0DD\uC0B0\uC644\uB8CC",
  "\uCD9C\uACE0\uB300\uAE30",
  "\uCD9C\uACE0\uC644\uB8CC",
  "\uC8FC\uBB38\uCDE8\uC18C"
]).describe("\uC8FC\uBB38 \uC0C1\uD0DC");
const DELIVERY_CODE_TABLE = {
  \uBC29\uBB38: 0,
  // Default Number
  \uBC30\uC45D\uC640\uC45D: 1,
  \uB300\uB9AC\uBC30\uC1A1: 2,
  \uCC29\uBD88\uD0DD\uBC30: 3,
  \uC120\uBD88\uD0DD\uBC30: 4,
  \uD654\uBB3C: 5,
  \uCC29\uBD88\uD035: 6,
  \uC120\uBD88\uD035: 7,
  \uACE0\uC18D\uBC84\uC2A4: 8,
  \uD56D\uACF5\uBC30\uC1A1: 9,
  \uC120\uBC15\uBC30\uC1A1: 10
};
const DELIVERY_CODE_TO_NAME = Object.entries(DELIVERY_CODE_TABLE).reduce(
  (acc, [name, code]) => {
    acc[code] = name;
    return acc;
  },
  {}
);
const DeliveryMethodEnum = z.enum([
  "\uBC29\uBB38",
  "\uBC30\uC45D\uC640\uC45D",
  "\uB300\uB9AC\uBC30\uC1A1",
  "\uCC29\uBD88\uD0DD\uBC30",
  "\uC120\uBD88\uD0DD\uBC30",
  "\uD654\uBB3C",
  "\uCC29\uBD88\uD035",
  "\uC120\uBD88\uD035",
  "\uACE0\uC18D\uBC84\uC2A4",
  "\uD56D\uACF5\uBC30\uC1A1",
  "\uC120\uBC15\uBC30\uC1A1"
]).describe("\uBC30\uC1A1 \uBC29\uBC95");
const DLVY_STAT_TABLE = {
  \uC0DD\uC0B0\uC911: 0,
  // Default Number
  \uCD9C\uACE0\uB300\uAE30: 1,
  \uCD9C\uACE0\uC644\uB8CC: 2,
  \uCD9C\uACE0\uCDE8\uC18C: 3
};
const DeliveryStatus = z.enum(["\uC0DD\uC0B0\uC911", "\uCD9C\uACE0\uB300\uAE30", "\uCD9C\uACE0\uC644\uB8CC", "\uCD9C\uACE0\uCDE8\uC18C"]).describe("\uBC30\uC1A1 \uC0C1\uD0DC");
const OrdJobSchema = z.object({
  jobtype: z.string(),
  covercd: z.string(),
  pagecd: z.string(),
  jobno: z.number(),
  jobname: z.string(),
  sizeno: z.number(),
  sizename: z.string(),
  hsize: z.number(),
  wsize: z.number(),
  csize: z.number(),
  paperno: z.number(),
  paperrname: z.string(),
  color1no: z.number(),
  color1noadd: z.string().nullable(),
  colorno2: z.number().nullable(),
  colorno2add: z.string().nullable(),
  color1name: z.string(),
  color1nameadd: z.string().nullable(),
  color2name: z.string().nullable(),
  color2nameadd: z.string().nullable(),
  optno: z.number(),
  optname: z.string(),
  jobqty: z.number(),
  pagecnt: z.number().nullable(),
  qunit: z.string().nullable(),
  dcjob: z.number(),
  cost: z.number().nullable()
});
const OrdSubSchema = z.object({
  ordseq: z.number(),
  prodno: z.number(),
  prodname: z.string(),
  prodgroup: z.string(),
  ordqty: z.number(),
  ordcnt: z.number(),
  qunit: z.string(),
  cost: z.number(),
  costsup: z.number(),
  costtax: z.number(),
  dcsub: z.number(),
  weight: z.number(),
  awkcnt: z.number().nullable(),
  ordjob: z.array(OrdJobSchema)
});
const DlvyBoxSchema = z.object({
  dboxnum: z.string(),
  dlvyname: z.string(),
  dlvymcdname: z.string(),
  dlvystat: DeliveryStatus,
  dlvystdtexp: z.string(),
  // 필요시 z.string().datetime() 등으로 더 엄격하게 검증 가능
  dlvystdt: z.string().nullable(),
  costdlvy: z.number(),
  cost: z.number(),
  costsup: z.number(),
  costtax: z.number(),
  dcdlvy: z.number(),
  dcshop: z.number(),
  dcpoint: z.number(),
  dccupon: z.number(),
  dc: z.number(),
  amtreq: z.number(),
  amtrefund: z.number(),
  amtpay: z.number(),
  amtunpay: z.number(),
  ordkgram: z.number(),
  boxkgram: z.number(),
  boxcnt: z.number(),
  frzip: z.string().nullable(),
  fraddr: z.string(),
  frrsvname: z.string(),
  frtelh: z.string(),
  frtelm: z.string(),
  tozip: z.string(),
  toaddr: z.string(),
  torsvname: z.string(),
  totelh: z.string(),
  totelm: z.string(),
  ordnum: z.array(z.string()),
  shipnum: z.string().nullable()
});
const OrdInfoSchema = z.object({
  ordnum: z.string(),
  ordstat: z.number(),
  // 필요시 z.nativeEnum(ORD_STAT)으로 숫자 값 검증 가능
  ordstatname: OrderStatusEnum,
  // 정의된 Enum 사용
  jobstat: z.number(),
  jobstatname: z.string(),
  // 필요시 Enum 정의 추가
  jobpstat: z.number(),
  regdt: z.string(),
  // 필요시 z.string().datetime() 등으로 더 엄격하게 검증 가능
  rokdt: z.string().nullable(),
  ordtitle: z.string(),
  dcprod: z.number(),
  dcjob: z.number(),
  dcshop: z.number(),
  dcpoint: z.number(),
  dccupon: z.number(),
  dctotal: z.number(),
  cost: z.number(),
  costsup: z.number(),
  costtax: z.number(),
  amtreq: z.number(),
  amtpay: z.number(),
  amtunpay: z.number(),
  amtrefund: z.number(),
  weight: z.number(),
  ordsub: z.array(OrdSubSchema),
  dlvybox: DlvyBoxSchema
});
const RawFileInfoSchema = z.object({
  filestat: z.string().optional().nullable(),
  name: z.string().optional().nullable()
});
const RawReworkInfoSchema = z.object({
  jobstat: z.number().optional().nullable(),
  jobstatname: z.string().optional().nullable(),
  ordnum: z.string().optional().nullable(),
  rwkreason: z.string().optional().nullable()
});
const OrdInfoResultMapSchema = z.object({
  ordinfo: OrdInfoSchema,
  fileinfo: RawFileInfoSchema.optional().nullable(),
  reworkinfo: RawReworkInfoSchema.optional().nullable()
});
const OrdInfoApiResponseSchema = createApiResponseSchema(OrdInfoResultMapSchema);
export {
  DELIVERY_CODE_TABLE,
  DELIVERY_CODE_TO_NAME,
  DLVY_STAT_TABLE,
  DeliveryMethodEnum,
  DeliveryStatus,
  ORD_STAT,
  OrdInfoApiResponseSchema,
  OrdInfoSchema,
  OrderStatusEnum
};
//# sourceMappingURL=order.js.map